import first from 'lodash/first';
import { isDefined } from '../../../common/predicates';
const isAlarm = (model) => model.type === 'AWS/ALARM';
const isAlarmState = (property) => property.name === 'AWS/ALARM_STATE';
const getAlarmStatePropertyFromAssetModel = (alarmStatePropertyId) => ({ properties, name, }) => {
    const alarmStateProperty = properties === null || properties === void 0 ? void 0 : properties.find((property) => (property === null || property === void 0 ? void 0 : property.id) === alarmStatePropertyId && isAlarmState(property));
    return (alarmStateProperty && {
        ...alarmStateProperty,
        name,
    });
};
export const getAlarmStateProperty = (assetModel, alarmStatePropertyId) => {
    var _a;
    return first((_a = assetModel.assetModelCompositeModels) === null || _a === void 0 ? void 0 : _a.filter(isAlarm).map(getAlarmStatePropertyFromAssetModel(alarmStatePropertyId)).filter(isDefined));
};
